import { useSelector } from 'react-redux';
import { selectAuth } from '../../../redux/slices/auth';

function PermissionChecker({ children, permissions }) {
    const { user } = useSelector(selectAuth);

    if (Array.isArray(permissions) && permissions.length > 0 && !user?.permissions?.some(permission => permissions.includes(permission))) {
        return null;
    }
    return children;
}

export default PermissionChecker;